import { createContext } from 'react';
import * as THREE from 'three';

export type MotionPathState = {
  /** The user-defined, mutable, current goal position along the curve, it may be >1 or <0 */
  current: number;
  /** The combined curve */
  path: THREE.CurvePath<THREE.Vector3>;
  /** The focus object */
  tracker: React.RefObject<THREE.Object3D>;
  /** The target object that is moved along the curve */
  object: React.RefObject<THREE.Object3D>;
  /** The 0-1 normalised and damped current goal position along curve */
  offset: number;
  /** The current point on the curve */
  point: THREE.Vector3;
  /** The current tangent on the curve */
  tangent: THREE.Vector3;
  /** The next point on the curve */
  next: THREE.Vector3;
};

export const MotionPathContext = /* @__PURE__ */ createContext<MotionPathState>(null!);
